<template>
  <div class="prove-method-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="计算方式" prop="method">
            <el-select
              v-model="formDate.method"
              placeholder="请选择计算方式"
              clearable
              class="auto-width"
            >
              <el-option
                v-for="item in methodOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="原始数据" prop="valuex">
            <el-input v-model="formDate.valuex" placeholder="请输入非负整数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="变量数据" prop="valuey">
            <el-input v-model="formDate.valuey" placeholder="请输入非负整数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="原始数据承诺" prop="commitmentx">
            <el-input v-model="formDate.commitmentx" placeholder="请输入原始数据承诺"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="变量数据承诺" prop="commitmenty">
            <el-input v-model="formDate.commitmenty" placeholder="请输入变量数据承诺"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="原始数据随机因子" prop="openingx">
            <el-input v-model="formDate.openingx" placeholder="请输入原始数据随机因子"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="变量数据随机因子" prop="openingy">
            {{ formDate.commitment }}
            <el-input v-model="formDate.openingy" placeholder="请输入变量数据随机因子"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="commitment" label="commitment">
            <el-input v-model="commitment" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="proof" label="proof">
            <el-input v-model="proof" type="textarea" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="handleProve()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 146
  },
  data() {
    return {
      formDate: {
        valuex: null,
        valuey: null,
        commitmentx: '',
        commitmenty: '',
        openingx: '',
        openingy: '',
        method: ''
      },
      commitment: '',
      proof: '',
      methodOption: [
        {
          label: '承诺加数值',
          value: 'ProveAfterAddNum'
        },
        {
          label: '承诺加承诺',
          value: 'ProveAfterAddCommitment'
        },
        {
          label: '承诺减数值',
          value: 'ProveAfterSubNum'
        },
        {
          label: '承诺减承诺',
          value: 'ProveAfterSubCommitment'
        },
        {
          label: '承诺乘数值',
          value: 'ProveAfterMulNum'
        }
      ],
      // PedersenAddNum
      editRules: {
        method: [{ required: true, message: '请选择计算方式', trigger: 'blur' }],
        valuex: [
          { required: true, message: '请输入原始数据', trigger: 'blur' },
          { pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' }
        ],
        valuey: [
          { required: true, message: '请输入变量数据', trigger: 'blur' },
          { pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' }
        ],
        commitmentx: [{ required: true, message: '请输入原始数据承诺', trigger: 'blur' }],
        openingx: [{ required: true, message: '请输入原始数据随机因子', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 146
      }
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem('contractCompute'))) {
      this.formDate = JSON.parse(localStorage.getItem('contractCompute'))
      switch (JSON.parse(localStorage.getItem('contractCompute')).method) {
        case 'PedersenAddNum':
          this.formDate.method = 'ProveAfterAddNum'
          break
        case 'PedersenAddCommitment':
          this.formDate.method = 'ProveAfterAddCommitment'
          break
        case 'PedersenSubNum':
          this.formDate.method = 'ProveAfterSubNum'
          break
        case 'PedersenSubCommitment':
          this.formDate.method = 'ProveAfterSubCommitment'
          break
        case 'PedersenMulNum':
          this.formDate.method = 'ProveAfterMulNum'
          break
        default:
          this.formDate.method = ''
          break
      }
    } else {
      this.formDate.method = ''
    }
  },
  methods: {
    handleProve() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.formDate.valuex = Number(this.formDate.valuex)
          this.formDate.valuey = Number(this.formDate.valuey)

          this.$apis.bulletproofs.proveMethod(this.formDate).then(res => {
            if (res) {
              this.commitment = res.data.commitment
              this.proof = res.data.proof
              this.$message.success('链下计算成功!')
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.prove-method-wrapper {
  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}

</style>
